window.pages['where-buy'] = {
    init: function () {
        window.components.products.init();
        window.components.modalProduct.init();
    },
};
